import React from 'react';

const Knowledge = () => {
  return <div>Knowledge</div>;
};

export default Knowledge;
